// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R4X2h","questions":"styles_questions__36o2A","footer":"styles_footer__2rFEv"};